export default "__VITE_ASSET__76fe7227__"